import { getApi } from "./api_instance";

export const getWalletDetails = async (dispatch) => {
  try {
    return await getApi({
      apiUrl: "/payments/api/wallet",
      sendToken: true,
      dispatch,
    });
  } catch (error) {
    throw error;
  }
};
